module.exports = __webpack_public_path__ + "img/84.193c123e.svg";